export const Status = {
  ALL: "success",
  SOME: "ongoing",
  NONE: "errorRed",
};

export const HttpStatus = {
  BAD_REQUEST: 400,
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  TIMEOUT: 504,
};

export const SlowResponseStatuses = [
  HttpStatus.BAD_GATEWAY,
  HttpStatus.SERVICE_UNAVAILABLE,
  HttpStatus.TIMEOUT,
];
